import { NewsItem } from '../modules/home/gov-news/tab-news-content/all-content/all-content.container';
import { FormattedNewsItem, RawNewsItem } from '../types/news';

const apiUrl = process.env.PORTAL_URL || "";

export const reorganizeNews = <T extends NewsItem>(
  newsArray: T[][],
  itemsPerGroup = 2
): T[][] => {
  const newNews: T[][] = [];
  let tempArray: T[] = [];

  for (const item of newsArray.flat()) {
    tempArray.push(item);
    if (tempArray.length === itemsPerGroup) {
      newNews.push([...tempArray]);
      tempArray = [];
    }
  }

  if (tempArray.length) {
    newNews.push([...tempArray]);
  }

  return newNews;
};

export const sincePublished = (dataISO: string) => {
  const publishedDate: any = new Date(dataISO);
  const now: any = new Date();
  const diffMs = now - publishedDate;

  const diffMin = Math.floor(diffMs / 1000 / 60);
  const diffHours = Math.floor(diffMin / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMin < 1) return 'Publicado há menos de um minuto';
  if (diffMin < 60) return `Publicado há ${diffMin} minuto${diffMin === 1 ? '' : 's'}`;
  if (diffHours < 24) return `Publicado há ${diffHours} hora${diffHours === 1 ? '' : 's'}`;
  
  return `Publicado há ${diffDays} dia${diffDays === 1 ? '' : 's'}`;
}

export const formatNews = (newsData: RawNewsItem): FormattedNewsItem => {
  const { date_created, id, content, author, thumbnail, categories, title } = newsData;
  const formatCategories = Array.isArray(categories)
    ? categories.join(' | ')
    : categories;

  return {
    id,
    origin: "",
    title,
    image: thumbnail ? `${apiUrl}/api/news/assets/${thumbnail}` : undefined,
    category: formatCategories,
    date: sincePublished(date_created),
    authorRead: author,
    authorPicture: "",
    newsContent: content
  };
};

